import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService) {}

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
        newReq = newReq.clone({
            headers: newReq.headers.set('randomId', this._authService.randomId),
        });
        if (
            this._authService.accessToken &&
            !AuthUtils.isTokenExpired(this._authService.expiryDate)
        ) {
            newReq = req.clone({
                headers: req.headers.set(
                    'Authorization',
                    'Bearer ' + this._authService.accessToken,
                ),
            });
            if (!newReq.headers.has('Content-Type')) {
                newReq = newReq.clone({
                    headers: newReq.headers.set(
                        'Content-Type',
                        'application/json',
                    ),
                });
            }
            // else {
            //     req = req.clone({ headers: req.headers.delete('Content-Type') });
            // }

            if (!newReq.headers.has('Accept')) {
                newReq = newReq.clone({
                    headers: newReq.headers.set('Accept', 'application/json'),
                });
            }
            // newReq = newReq.clone({ headers: newReq.headers.set('Client-Type', 'ADMIN') });
        }
        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                // Catch "401 Unauthorized" responses
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === 401
                ) {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                }

                return throwError(error);
            }),
        );
    }
}
